import { render } from "./AutoReadingGas.vue?vue&type=template&id=224c5f9e&scoped=true"
import script from "./AutoReadingGas.vue?vue&type=script&lang=js"
export * from "./AutoReadingGas.vue?vue&type=script&lang=js"

import "./AutoReadingGas.vue?vue&type=style&index=0&id=224c5f9e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224c5f9e"]])

export default __exports__